import isUndefined from 'lodash/isUndefined';
import { PhoneNumberType } from 'src/actions/availableNumbers/availableNumbersResource';
import { PhoneNumberCapability } from 'src/actions/availableNumbers/availableNumbersResource';
// helper function to get stages dynamically from stages Schema
export interface StageConfig {
  stageId: string;
  stage: JSX.Element | null;
  nextStages: { stageId: string; showStage?: boolean }[];
}

export interface StageConfigState {
  numberPreference: NumberPreference;
  activateVoice: boolean;
  linkIvr: boolean;
  ivr: {
    initialIvrId: string;
    queueIvrId: string;
    queueIvrWaitDuration: string;
  };
  selectedPhone: {
    id: string;
    locality: string;
    region: string;
    phoneNumber: string;
    countryCode: string;
    phoneNumberType: PhoneNumberType;
    capabilities: PhoneNumberCapability[];
  };
}

export const getStagesList = (stagesSchema: StageConfig[]): StageConfig[] => {
  const { steps } = stagesSchema.reduce(
    (acc: any, stageConfig, index) => {
      const renderStage = index === 0 || acc.stagesToRender.has(stageConfig.stageId);
      if (renderStage) {
        acc.steps.push(stageConfig);
        const nextStage = stageConfig.nextStages.find(({ showStage }) => showStage === true || isUndefined(showStage));
        if (nextStage) {
          acc.stagesToRender.set(nextStage.stageId, true);
        }
      }
      return acc;
    },
    { stagesToRender: new Map(), steps: [] }
  );
  return steps;
};

export enum NumberPreference {
  new = 'new',
  exists = 'exists',
  port = 'port',
}
